export enum SegmentExternalEvents {
  BrandCreatorReview = 'Brand Creator Review',
  BrandPostReview = 'Brand Post Review',
  PageFilter = 'Page Filter',
  ColumnSort = 'Column Sort',
}
